const isMfDomain = window.location.hostname.includes('mfrealstate');
export const MF_BASE = isMfDomain ? '' : '/mf-real-state';
